import React from 'react';
import type { ExperienceAttributes } from '@atlassian/jira-experience-tracker/src/common/types.tsx';
import { useExperienceTracker } from '@atlassian/jira-software-logging/src/services/experience-tracker/index.tsx';
import { SoftwareExperienceStart } from '@atlassian/jira-software-logging/src/ui/experience-tracker/experience-start/index.tsx';
import { SoftwareExperienceSuccess } from '@atlassian/jira-software-logging/src/ui/experience-tracker/experience-success/index.tsx';
import { ANALYTICS_SOURCE_VERSION_PANEL, APP_ID } from '../../common/constants.tsx';

export const VIEW_EXPERIENCE_NAME = 'viewVersionBacklogPanel';

export const ASSIGN_EXPERIENCE_NAME = 'assignVersionPanel';
export const ASSIGN_ABORT_PERMISSION = 'ASSIGN_PERMISSION';
export const ASSIGN_ABORT_CROSS_PROJECT = 'ASSIGN_CROSS_PROJECT';

export const UNASSIGN_EXPERIENCE_NAME = 'unassignVersionPanel';
export const UNASSIGN_ABORT_PERMISSION = 'UNASSIGN_PERMISSION';

type Props = {
	experienceId?: string;
};

export const useViewVersionPanelExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(APP_ID, VIEW_EXPERIENCE_NAME, ANALYTICS_SOURCE_VERSION_PANEL, attributes);

export const VersionBacklogPanelExperienceStart = ({ experienceId = APP_ID }: Props) => (
	<SoftwareExperienceStart
		experienceId={experienceId}
		experience={VIEW_EXPERIENCE_NAME}
		analyticsSource={ANALYTICS_SOURCE_VERSION_PANEL}
	/>
);

export const VersionBacklogPanelExperienceSuccessTracker = ({
	attributes,
}: {
	attributes?: ExperienceAttributes;
}) => <SoftwareExperienceSuccess experience={VIEW_EXPERIENCE_NAME} attributes={attributes} />;

export const useAssignExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(APP_ID, ASSIGN_EXPERIENCE_NAME, ANALYTICS_SOURCE_VERSION_PANEL, attributes);

export const useUnassignExperienceTracker = (attributes: ExperienceAttributes = {}) =>
	useExperienceTracker(
		APP_ID,
		UNASSIGN_EXPERIENCE_NAME,
		ANALYTICS_SOURCE_VERSION_PANEL,
		attributes,
	);
